<template>
    <div>
        <div class="detail-data-wrapper mb-4">
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label"><strong>No. Faktur</strong></b-col>
                <b-col v-if="detailGadai.noFaktur != null"><strong>{{ detailGadai.noFaktur }}</strong></b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Pembuat Faktur</b-col>
                <b-col v-if="detailGadai.createdBy != null"><strong>{{ formatCreatedBy(detailGadai.createdBy) }}</strong></b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Status Gadai</b-col>
                <b-col v-if="detailGadai.statusGadai != null">{{ detailGadai.statusGadai }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Posisi Barang</b-col>
                <b-col v-if="detailGadai.posisiBarang != null">{{ detailGadai.posisiBarang }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
        </div>

        <div class="detail-data-wrapper mb-4">
            <h6 class="form-title">DATA ANGGOTA</h6>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">No. Anggota</b-col>
                <b-col v-if="detailGadai.anggota.noAnggota != null"><strong>{{ detailGadai.anggota.noAnggota }}</strong></b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Jenis Identitas</b-col>
                <b-col v-if="detailGadai.anggota.jenisIdentitas != null">{{ detailGadai.anggota.jenisIdentitas }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">No. Identitas</b-col>
                <b-col v-if="detailGadai.anggota.noIdentitas != null">{{ detailGadai.anggota.noIdentitas }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Nama</b-col>
                <b-col v-if="detailGadai.anggota.namaAnggota != null">{{ detailGadai.anggota.namaAnggota }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Alamat</b-col>
                <b-col v-if="detailGadai.anggota.alamat != null">{{ detailGadai.anggota.alamat }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">No. Handphone</b-col>
                <b-col v-if="detailGadai.anggota.noHp != null">{{ detailGadai.anggota.noHp }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
        </div>

        <div v-if="detailGadai.barang.kendaraan == null" class="detail-data-wrapper mb-4">
            <h6 class="form-title">DATA BARANG</h6>
            
                <div v-if="detailGadai.barang.jenis.id == 251">
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Jenis Barang</b-col>
                        <b-col v-if="detailGadai.barang.jenis != null">{{ detailGadai.barang.jenis.name }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Merk Barang</b-col>
                        <b-col v-if="detailGadai.barang.merk != null">{{ detailGadai.barang.merk.name }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Tipe Barang</b-col>
                        <b-col v-if="detailGadai.barang.tipe != null">{{ detailGadai.barang.tipe.name }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>

                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Merk Cap Emas</b-col>
                        <b-col v-if="detailGadai.barang.emasDetail.cap != null && detailGadai.barang.emasDetail.cap.id != null">{{ detailGadai.barang.emasDetail.cap.name }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>

                    <b-row v-if="detailGadai.barang.emasDetail != null &&  detailGadai.barang.emasDetail.kemasan.id != null" class="mb-2">
                        <b-col cols="4" class="detail-data-label">Jenis Kemasan Emas</b-col>
                        <b-col >{{ detailGadai.barang.emasDetail.kemasan.name }}</b-col>
                    </b-row>
             
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Jumlah Keping</b-col>
                        <b-col>{{ detailGadai.barang.emasDetail.keping }} Keping</b-col>
                    </b-row>

                    <!-- <b-row class="mb-2" v-if="detailGadai.barang.jenis.id === 251">
                        <b-col cols="4" class="detail-data-label">SN</b-col>
                        <b-col >{{ detailGadai.barang.noImei }}</b-col>
                    </b-row> -->
              
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Kelengkapan Barang</b-col>
                        <b-col v-if="detailGadai.barang.kelengkapan.filter(i => i && i.trim() !== '').length >= 1">
                            <ul class="list-circle-wrapper">
                                <li v-for="item in detailGadai.barang.kelengkapan"  v-bind:key="item">
                                    {{ item }}
                                </li>
                            </ul>
                        </b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Kondisi/Kerusakan/Keterangan Lainnya</b-col>
                        <b-col v-if="$helper.isNotNullAndNotEmpty(detailGadai.barang.keterangan)">{{ detailGadai.barang.keterangan }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
            
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Foto</b-col>
                        <b-col v-if="$helper.isNotNullAndNotEmpty(detailGadai.foto)">
                            <ModalFoto
                                v-if="showModalFoto"
                                isButton
                                withLength
                                :photos="detailGadai.foto"
                            />

                            <b-button
                                v-if="showFotoButton"
                                size="sm"
                                variant="pgiBtn"
                                @click="onActiveFoto"
                            >
                                <i class="fa fa-eye"></i>
                                {{ isActiveFotoRight || isActiveFotoMobile ? 'Tutup Foto' : `Lihat ${detailGadai.foto.length} Foto` }}
                            </b-button>
                        </b-col>
                        <b-col v-else>-</b-col>
                        <b-col cols="12" v-if="isActiveFotoMobile" class="mt-3">
                            <ImageCard
                                v-for="(urlFoto, index) in detailGadai.foto"
                                :key="index"
                                :src="urlFoto"
                                :title="'Foto ' + (index + 1)" 
                                @preview="openPreview"
                            />
                        </b-col>
                    </b-row>
                </div>
                <div v-else-if="detailGadai.barang.jenis.id == 257">
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Jenis Barang</b-col>
                        <b-col v-if="detailGadai.barang.jenis != null">{{ detailGadai.barang.jenis.name }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Merk Barang</b-col>
                        <b-col v-if="detailGadai.barang.merk != null">{{ detailGadai.barang.merk.name }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Tipe Barang</b-col>
                        <b-col v-if="detailGadai.barang.tipe != null"> {{ detailGadai.barang.tipe.name }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Daftar Potongan</b-col>
                        <b-col v-if="detailGadai.barang.emasDetail.listPotonganBerat != null && detailGadai.barang.emasDetail.listPotonganBerat.length != 0" class="detail-data-label">
                            <div v-for="item of detailGadai.barang.emasDetail.listPotonganBerat" >
                                - {{ item }}
                            </div>
                        </b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Hasil Gosokan</b-col>
                        <b-col v-if="detailGadai.barang.emasDetail.gosokanHilang == true">Hilang</b-col>
                        <b-col v-else>Tidak Hilang</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Cap Karat</b-col>
                        <b-col v-if="detailGadai.barang.emasDetail.adaCap == true">Ada</b-col>
                        <b-col v-else>Tidak Ada</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Ada Merk Perusahaan</b-col>
                        <b-col>{{ getLabelAdaMerkPerusahaan(detailGadai.barang.emasDetail.adaLogoPerusahaan) }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Kwitansi</b-col>
                        <b-col v-if="detailGadai.barang.emasDetail.adaKwitansi == true">Ada</b-col>
                        <b-col v-else>Tidak Ada</b-col>
                    </b-row>
                    <b-row v-if="detailGadai.barang.emasDetail.kemasan && detailGadai.barang.emasDetail.kemasan.id != null" class="mb-2">
                        <b-col cols="4" class="detail-data-label">Jenis Kemasan Emas</b-col>
                        <b-col >{{ detailGadai.barang.emasDetail.kemasan.name }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Merk Emas</b-col>
                        <b-col v-if="detailGadai.barang.emasDetail.cap != null">{{ detailGadai.barang.emasDetail.cap.name }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Angka Cap</b-col>
                        <b-col v-if="$helper.isNotNullAndNotEmpty(detailGadai.barang.emasDetail.pointCap)">{{ detailGadai.barang.emasDetail.pointCap }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Berat Kering</b-col>
                        <b-col>{{ detailGadai.barang.emasDetail.beratKering }} gram</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Potongan Berat</b-col>
                        <b-col>{{ detailGadai.barang.emasDetail.potonganBerat }} gram</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Berat Emas</b-col>
                        <b-col>{{ detailGadai.barang.emasDetail.beratEmas }} gram</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Spesifikasi Barang</b-col>
                        <b-col v-if="detailGadai.barang.spesifikasi.length >= 1">
                            <ul class="list-circle-wrapper">
                                <li v-for="(item, idx) in detailGadai.barang.spesifikasi"  v-bind:key="idx">
                                    {{ item.name }}
                                </li>
                            </ul>
                        </b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Kelengkapan Barang</b-col>
                        <b-col v-if="detailGadai.barang.kelengkapan.filter(i => i && i.trim() !== '').length >= 1">
                            <ul class="list-circle-wrapper">
                                <li v-for="item in detailGadai.barang.kelengkapan"  v-bind:key="item">
                                    {{ item }}
                                </li>
                            </ul>
                        </b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Kondisi/Kerusakan/Keterangan Lainnya</b-col>
                        <b-col v-if="$helper.isNotNullAndNotEmpty(detailGadai.barang.keterangan)">{{ detailGadai.barang.keterangan }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>

                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Foto</b-col>
                        <b-col v-if="$helper.isNotNullAndNotEmpty(detailGadai.foto)">
                            <ModalFoto
                                v-if="showModalFoto"
                                isButton
                                withLength
                                :photos="detailGadai.foto"
                            />

                            <b-button
                                v-if="showFotoButton"
                                size="sm"
                                variant="pgiBtn"
                                @click="onActiveFoto"
                            >
                                <i class="fa fa-eye"></i>
                                {{ isActiveFotoRight || isActiveFotoMobile ? 'Tutup Foto' : `Lihat ${detailGadai.foto.length} Foto` }}
                            </b-button>
                        </b-col>
                        <b-col v-else>-</b-col>
                        <b-col cols="12" v-if="isActiveFotoMobile" class="mt-3">
                            <ImageCard
                                v-for="(urlFoto, index) in detailGadai.foto"
                                :key="index"
                                :src="urlFoto"
                                :title="'Foto ' + (index + 1)" 
                                @preview="openPreview"
                            />
                        </b-col>
                    </b-row>
                </div>
                <div v-else-if="detailGadai.barang.jenis.id == 261">
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Jenis Barang</b-col>
                        <b-col v-if="detailGadai.barang.jenis != null">{{ detailGadai.barang.jenis.name }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Merk Barang</b-col>
                        <b-col v-if="detailGadai.barang.merk != null">{{ detailGadai.barang.merk.name }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Tipe Barang</b-col>
                        <b-col v-if="detailGadai.barang.tipe != null"> {{ detailGadai.barang.tipe.name }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Daftar Potongan</b-col>
                        <b-col v-if="detailGadai.barang.emasDetail.listPotonganBerat != null && detailGadai.barang.emasDetail.listPotonganBerat.length != 0" class="detail-data-label">
                            <div v-for="item of detailGadai.barang.emasDetail.listPotonganBerat" >
                                - {{ item }}
                            </div>
                        </b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Hasil Gosokan</b-col>
                        <b-col v-if="detailGadai.barang.emasDetail.gosokanHilang == true">Hilang</b-col>
                        <b-col v-else>Tidak Hilang</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Cap Karat</b-col>
                        <b-col v-if="detailGadai.barang.emasDetail.adaCap == true">Ada</b-col>
                        <b-col v-else>Tidak Ada</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Ada Merk Perusahaan</b-col>
                        <b-col>{{ getLabelAdaMerkPerusahaan(detailGadai.barang.emasDetail.adaLogoPerusahaan) }}</b-col>
                    </b-row>
                    <b-row v-if="detailGadai.barang.emasDetail.kemasan && detailGadai.barang.emasDetail.kemasan.id != null" class="mb-2">
                        <b-col cols="4" class="detail-data-label">Jenis Kemasan Emas</b-col>
                        <b-col >{{ detailGadai.barang.emasDetail.kemasan.name }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Merk Emas</b-col>
                        <b-col v-if="detailGadai.barang.emasDetail.cap != null">{{ detailGadai.barang.emasDetail.cap.name }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Berat Kering</b-col>
                        <b-col>{{ detailGadai.barang.emasDetail.beratKering }} gram</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Potongan Berat</b-col>
                        <b-col>{{ detailGadai.barang.emasDetail.potonganBerat }} gram</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Berat Emas</b-col>
                        <b-col>{{ detailGadai.barang.emasDetail.beratEmas }} gram</b-col>
                    </b-row>
                   
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Cap Tempelan</b-col>
                        <b-col v-if="detailGadai.barang.emasDetail.potonganKaratCapTempelan != 0">Ya (- {{ detailGadai.barang.emasDetail.potonganKaratCapTempelan }} Karat)</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Spesifikasi Barang</b-col>
                        <b-col v-if="detailGadai.barang.spesifikasi.length >= 1">
                            <ul class="list-circle-wrapper">
                                <li v-for="(item, idx) in detailGadai.barang.spesifikasi"  v-bind:key="idx">
                                    {{ item.name }}
                                </li>
                            </ul>
                        </b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Kelengkapan Barang</b-col>
                        <b-col v-if="detailGadai.barang.kelengkapan.filter(i => i && i.trim() !== '').length >= 1">
                            <ul class="list-circle-wrapper">
                                <li v-for="item in detailGadai.barang.kelengkapan"  v-bind:key="item">
                                    {{ item }}
                                </li>
                            </ul>
                        </b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Kondisi/Kerusakan/Keterangan Lainnya</b-col>
                        <b-col v-if="$helper.isNotNullAndNotEmpty(detailGadai.barang.keterangan)">{{ detailGadai.barang.keterangan }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>

                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Foto</b-col>
                        <b-col v-if="$helper.isNotNullAndNotEmpty(detailGadai.foto)">
                            <ModalFoto
                                v-if="showModalFoto"
                                isButton
                                withLength
                                :photos="detailGadai.foto"
                            />

                            <b-button
                                v-if="showFotoButton"
                                size="sm"
                                variant="pgiBtn"
                                @click="onActiveFoto"
                            >
                                <i class="fa fa-eye"></i>
                                {{ isActiveFotoRight || isActiveFotoMobile ? 'Tutup Foto' : `Lihat ${detailGadai.foto.length} Foto` }}
                            </b-button>
                        </b-col>
                        <b-col v-else>-</b-col>
                        <b-col cols="12" v-if="isActiveFotoMobile" class="mt-3">
                            <ImageCard
                                v-for="(urlFoto, index) in detailGadai.foto"
                                :key="index"
                                :src="urlFoto"
                                :title="'Foto ' + (index + 1)" 
                                @preview="openPreview"
                            />
                        </b-col>
                    </b-row>
                </div>
		
            <div v-else>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Jenis Barang</b-col>
                    <b-col v-if="detailGadai.barang.jenis != null">{{ detailGadai.barang.jenis.name }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Merk Barang</b-col>
                    <b-col v-if="detailGadai.barang.merk != null">{{ detailGadai.barang.merk.name }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Tipe Barang</b-col>
                    <b-col v-if="detailGadai.barang.tipe != null">{{ detailGadai.barang.tipe.name }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row v-if="detailGadai.barang.emasDetail != null &&  detailGadai.barang.emasDetail.kemasan.id != null" class="mb-2">
                    <b-col cols="4" class="detail-data-label">Jenis Kemasan Emas</b-col>
                    <b-col >{{ detailGadai.barang.emasDetail.kemasan.name }}</b-col>
                </b-row>
                
                <b-row v-if="detailGadai.barang.emasDetail != null && detailGadai.barang.emasDetail.cap != null" class="mb-2">
                    <b-col cols="4" class="detail-data-label">Merk Emas</b-col>
                    <b-col >{{ detailGadai.barang.emasDetail.cap.name }}</b-col>
                </b-row>

                <b-row v-if="detailGadai.barang.emasDetail != null && detailGadai.barang.emasDetail.pointCap != null" class="mb-2">
                    <b-col cols="4" class="detail-data-label">Angka Cap</b-col>
                    <b-col>{{ detailGadai.barang.emasDetail.pointCap }}</b-col>
                </b-row>

                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Spek</b-col>
                    <b-col>
                        <div v-if="detailGadai.barang && detailGadai.barang.spek == 2">RESMI</div>
                        <div v-else-if="detailGadai.barang && detailGadai.barang.spek == 5">LN</div>
                        <div v-else>-</div>
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">No. Model</b-col>
                    <b-col v-if="detailGadai.barang.tipe && detailGadai.barang.tipe.noModel">
                        {{ (detailGadai.barang.tipe && detailGadai.barang.tipe.noModel) ?detailGadai.barang.tipe.noModel :'-' }}
                    </b-col>
                    <b-col>
                        {{ (detailGadai.barang.modelNumber) ?((detailGadai.barang.modelNumber == 'Lainnya') ?detailGadai.barang.modelNumberLainnya :detailGadai.barang.modelNumber) :'-' }}
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Tahun / Generasi</b-col>
                    <b-col v-if="detailGadai.barang.tahun != null">{{ detailGadai.barang.tahun }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row v-if="detailGadai.barang.laptop != null" class="mb-2">
                    <b-col cols="4" class="detail-data-label">Spesifikasi Laptop</b-col>
                    <b-col>{{ detailGadai.barang.laptop.spesifikasiLaptop }}</b-col>
                </b-row>
                <b-row v-if="detailGadai.barang.laptop != null" class="mb-2">
                    <b-col cols="4" class="detail-data-label">RAM Laptop</b-col>
                    <b-col>{{ detailGadai.barang.laptop.ram }} GB</b-col>
                </b-row>
                <b-row v-if="detailGadai.barang.laptop != null" class="mb-2">
                    <b-col cols="4" class="detail-data-label">Hardisk Laptop</b-col>
                    <b-col>{{ detailGadai.barang.laptop.gadaiJenisHardisk }} {{ detailGadai.barang.laptop.gadaiSizeHardisk }}</b-col>
                </b-row>
                <b-row v-if="detailGadai.barang.kendaraan == null">
                    <b-col cols="4" class="detail-data-label">No. IMEI / SN</b-col>
                    <b-col v-if="detailGadai.barang.noImei != null">
                        {{ detailGadai.barang.noImei }}
                        <b-button v-if="isShowEditImei && IS_HAVE_PERMISSION_EDIT_IMEI" size="sm" variant="primary" class="ml-2" @click="onShowModalEditImei()">
                            <i class="fa fa-edit"></i>
                            Edit
                        </b-button>
                    </b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Password</b-col>
                    <b-col v-if="detailGadai.barang.password != null">{{ detailGadai.barang.password }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Grade Barang</b-col>
                    <b-col v-if="detailGadai.barang.gradeKondisi != null">{{ detailGadai.barang.gradeKondisi.name }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Warna</b-col>
                    <b-col v-if="detailGadai.barang.warna != null">{{ detailGadai.barang.warna.name }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Kelengkapan Barang</b-col>
                    <b-col v-if="detailGadai.barang.kelengkapan.filter(i => i && i.trim() !== '').length >= 1">
                        <ul class="list-circle-wrapper">
                            <li v-for="item in detailGadai.barang.kelengkapan"  v-bind:key="item">
                                {{ item }}
                            </li>
                        </ul>
                    </b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Spesifikasi Barang</b-col>
                    <b-col v-if="detailGadai.barang.spesifikasi.length >= 1">
                        <ul class="list-circle-wrapper">
                            <li v-for="(item, idx) in detailGadai.barang.spesifikasi"  v-bind:key="idx">
                                {{ item.name }}
                            </li>
                        </ul>
                    </b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Kondisi / Kerusakan / Keterangan Lainnya</b-col>
                    <b-col v-if="$helper.isNotNullAndNotEmpty(detailGadai.barang.keterangan)">{{ detailGadai.barang.keterangan }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>

                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Foto</b-col>
                    <b-col v-if="$helper.isNotNullAndNotEmpty(detailGadai.foto)">
                        <ModalFoto
                            v-if="showModalFoto"
                            isButton
                            withLength
                            :photos="detailGadai.foto"
                        />

                        <b-button
                            v-if="showFotoButton"
                            size="sm"
                            variant="pgiBtn"
                            @click="onActiveFoto"
                        >
                            <i class="fa fa-eye"></i>
                            {{ isActiveFotoRight || isActiveFotoMobile ? 'Tutup Foto' : `Lihat ${detailGadai.foto.length} Foto` }}
                        </b-button>
                    </b-col>
                    <b-col v-else>-</b-col>
                    <b-col cols="12" v-if="isActiveFotoMobile" class="mt-3">
                        <ImageCard
                            v-for="(urlFoto, index) in detailGadai.foto"
                            :key="index"
                            :src="urlFoto"
                            :title="'Foto ' + (index + 1)" 
                            @preview="openPreview"
                        />
                    </b-col>
                </b-row>
            </div>
        </div>

        <div v-if="detailGadai.barang.kendaraan != null" class="detail-data-wrapper mb-4">
            <h6 class="form-title">DATA KENDARAAN</h6>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Tipe Pinjaman</b-col>
                <b-col v-if="detailGadai.barang.withKendaraan == true">Kendaraan + BPKB</b-col>
                <b-col v-else>BPKB Saja</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Jenis Kendaraan</b-col>
                <b-col v-if="detailGadai.barang.jenis != null">{{ detailGadai.barang.jenis.name }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">No. Polisi</b-col>
                <b-col v-if="detailGadai.barang.kendaraan.noPolisi != null">{{ detailGadai.barang.kendaraan.noPolisi }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Merk</b-col>
                <b-col v-if="detailGadai.barang.merk != null">{{ detailGadai.barang.merk.name }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Tipe</b-col>
                <b-col v-if="detailGadai.barang.tipe != null">{{ detailGadai.barang.tipe.name }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Tahun</b-col>
                <b-col v-if="detailGadai.barang.tahun != null">{{ detailGadai.barang.tahun }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Kondisi</b-col>
                <b-col v-if="detailGadai.barang.gradeKondisi != null">{{ detailGadai.barang.gradeKondisi.name }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Warna</b-col>
                <b-col v-if="detailGadai.barang.warna != null">{{ detailGadai.barang.warna.name }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Kelengkapan Barang</b-col>
                <b-col v-if="detailGadai.barang.kelengkapan.filter(i => i && i.trim() !== '').length >= 1">
                    <ul class="list-circle-wrapper">
                        <li v-for="item in detailGadai.barang.kelengkapan"  v-bind:key="item">
                            {{ item }}
                        </li>
                    </ul>
                </b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Status</b-col>
                <b-col v-if="detailGadai.barang.kendaraan.status != null">{{ detailGadai.barang.kendaraan.status }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Spesifikasi Barang</b-col>
                <b-col v-if="detailGadai.barang.spesifikasi.length >= 1">
                    <ul class="list-circle-wrapper">
                        <li v-for="(item, idx) in detailGadai.barang.spesifikasi"  v-bind:key="idx">
                            {{ item.name }}
                        </li>
                    </ul>
                </b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Foto</b-col>
                <b-col v-if="$helper.isNotNullAndNotEmpty(detailGadai.foto)">
                    <ModalFoto
                        v-if="showModalFoto"
                        isButton
                        withLength
                        :photos="detailGadai.foto"
                    />

                    <b-button
                        v-if="showFotoButton"
                        size="sm"
                        variant="pgiBtn"
                        @click="onActiveFoto"
                    >
                        <i class="fa fa-eye"></i>
                        {{ isActiveFotoRight || isActiveFotoMobile ? 'Tutup Foto' : `Lihat ${detailGadai.foto.length} Foto` }}
                    </b-button>
                </b-col>
                <b-col v-else>-</b-col>
                <b-col cols="12" v-if="isActiveFotoMobile" class="mt-3">
                    <ImageCard
                        v-for="(urlFoto, index) in detailGadai.foto"
                        :key="index"
                        :src="urlFoto"
                        :title="'Foto ' + (index + 1)" 
                        @preview="openPreview"
                    />
                </b-col>
            </b-row>
        </div>

        <div v-if="detailGadai.barang.kendaraan != null" class="detail-data-wrapper mb-4">
            <h6 class="form-title">DATA STNK</h6>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">STNK Atas Nama</b-col>
                <b-col v-if="detailGadai.barang.kendaraan.namaSTNK != null">{{ detailGadai.barang.kendaraan.namaSTNK }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Kota STNK</b-col>
                <b-col v-if="detailGadai.barang.kendaraan.kotaSTNK != null">{{ detailGadai.barang.kendaraan.kotaSTNK.name }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Kecamatan STNK</b-col>
                <b-col v-if="detailGadai.barang.kendaraan.kecamatanSTNK != null">{{ detailGadai.barang.kendaraan.kecamatanSTNK.name }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Kelurahan STNK</b-col>
                <b-col v-if="detailGadai.barang.kendaraan.kelurahanSTNK != null">{{ detailGadai.barang.kendaraan.kelurahanSTNK.name }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">RT</b-col>
                <b-col v-if="detailGadai.barang.kendaraan.rtSTNK != null">{{ $helper.formatThreeDigitNumber(detailGadai.barang.kendaraan.rtSTNK) }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">RW</b-col>
                <b-col v-if="detailGadai.barang.kendaraan.rwSTNK != null">{{ $helper.formatThreeDigitNumber(detailGadai.barang.kendaraan.rwSTNK) }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Alamat STNK</b-col>
                <b-col v-if="detailGadai.barang.kendaraan.alamatSTNK != null">{{ detailGadai.barang.kendaraan.alamatSTNK }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Masa Berlaku Pajak</b-col>
                <b-col v-if="detailGadai.barang.kendaraan.pajakSTNK != null">{{$helper.changeDateFormat(detailGadai.barang.kendaraan.pajakSTNK)}}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
        </div>

        <div v-if="detailGadai.barang.kendaraan != null" class="detail-data-wrapper mb-4">
            <h6 class="form-title">DATA BPKB</h6>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">No. BPKB</b-col>
                <b-col v-if="detailGadai.barang.kendaraan.noBPKB != null">{{ detailGadai.barang.kendaraan.noBPKB }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">BPKB Atas Nama</b-col>
                <b-col v-if="detailGadai.barang.kendaraan.namaBPKB != null">{{ detailGadai.barang.kendaraan.namaBPKB }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">No. Mesin</b-col>
                <b-col v-if="detailGadai.barang.kendaraan.noMesin != null">{{ detailGadai.barang.kendaraan.noMesin }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">No. Rangka</b-col>
                <b-col v-if="detailGadai.barang.kendaraan.noRangka != null">{{ detailGadai.barang.kendaraan.noRangka }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
        </div>

        <div class="detail-data-wrapper mb-4">
            <h6 class="form-title">DATA PINJAMAN</h6>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Cabang Penggadaian</b-col>
                <b-col v-if="detailGadai.cabangPenggadaian != null">{{ detailGadai.cabangPenggadaian.name }}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Tanggal Gadai</b-col>
                <b-col v-if="detailGadai.tanggalGadai != null">{{$helper.changeDateFormat(detailGadai.tanggalGadai)}}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Tanggal Jatuh Tempo</b-col>
                <b-col v-if="detailGadai.tanggalJatuhTempo != null">{{$helper.changeDateFormat(detailGadai.tanggalJatuhTempo)}}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">
                    Nilai Taksiran
                </b-col>
                <b-col v-if="detailGadai.nilaiTaksiran != null">Rp. {{$helper.addThousandSeparator(detailGadai.nilaiTaksiran)}}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">
                    Pinjaman Maksimum
                </b-col>
                <b-col v-if="detailGadai.pinjamanMaksimum != null">Rp. {{$helper.addThousandSeparator(detailGadai.pinjamanMaksimum)}}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">
                    Pinjaman Pokok Awal
                    <i class="fa fa-info tooltip-trigger-btn ml-1" id="tooltip-pinjaman-awal"></i>
                </b-col>
                <b-tooltip target="tooltip-pinjaman-awal" triggers="hover">
                    Nominal pinjaman yang diambil nasabah saat penggadaian dilakukan.
                </b-tooltip>
                <b-col v-if="detailGadai.pinjamanPokokAwal != null">Rp. {{$helper.addThousandSeparator(detailGadai.pinjamanPokokAwal)}}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">
                    Pinjaman Pokok Efektif
                    <i class="fa fa-info tooltip-trigger-btn ml-1" id="tooltip-pinjaman-efektif"></i>
                </b-col>
                <b-tooltip target="tooltip-pinjaman-efektif" triggers="hover">
                    Nominal pinjaman pokok tersisa sekarang (bila ada angsuran pokok)
                </b-tooltip>
                <b-col v-if="detailGadai.pinjamanPokokEfektif != null">Rp. {{$helper.addThousandSeparator(detailGadai.pinjamanPokokEfektif)}}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Harga Barang</b-col>
                <b-col v-if="detailGadai.hargaBarang != null">Rp. {{$helper.addThousandSeparator(detailGadai.hargaBarang)}}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2" v-if="detailGadai.biayaAsuransi != null">
                <b-col cols="4" class="detail-data-label">Biaya Asuransi</b-col>
                <b-col>
                    Rp. {{ $helper.addThousandSeparator(detailGadai.biayaAsuransi) }}
                </b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Biaya Admin</b-col>
                <b-col v-if="detailGadai.hargaAdminAwal != null">Rp. {{$helper.addThousandSeparator(detailGadai.hargaAdminAwal)}}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Biaya Layanan Bank</b-col>
                <b-col v-if="feeBank">Rp. {{$helper.addThousandSeparator(feeBank)}}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Jasa Awal</b-col>
                <b-col v-if="detailGadai.jasaAwal != null">Rp. {{$helper.addThousandSeparator(detailGadai.jasaAwal)}}</b-col>
                <b-col v-else>-</b-col>
            </b-row>

            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Diskon Voucher</b-col>
                <b-col v-if="detailGadai.diskonVoucher != null">Rp. {{$helper.addThousandSeparator(detailGadai.diskonVoucher)}}</b-col>
                <b-col v-else>-</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Promo</b-col>
                <b-col v-if="detailGadai.promo.length !=  0">
                    <ul class="list-circle-wrapper">
                        <li v-for="(item, idx) in detailGadai.promo"  v-bind:key="idx">
                            {{ item }}
                        </li>
                    </ul>
                </b-col>
                <b-col v-else>-</b-col>
            </b-row>
        </div>
        
        <div class="detail-data-wrapper mb-4" v-if="showHistoryPembayaran">
            <h6 class="form-title">HISTORI PEMBAYARAN</h6>
            <b-table bordered hover show-empty :fields="field" :items="detailGadai.pembayaran" responsive class="mb-3">
                <template v-slot:empty>
                    Tidak ada data histori pembayaran.
                </template>
                <template v-slot:cell(tanggalPembayaran)="row">
                    <p class="mb-0">{{$helper.changeDateFormat(row.item.tanggalPembayaran)}}</p>
                    <p class="mb-0 smallText text-muted">{{row.item.cabangPembayaran}}</p>
                </template>
                <template v-slot:cell(jenisPembayaran)="row">
                    <div>
                        <div>
                            <p class="mb-0">{{row.item.jenisPembayaran}}</p>
                        </div>
                        <div>
                            <span class="smallText text-muted" v-if="row.item.pembayaranTunai == true">Tunai </span>
                            <span class="smallText text-muted" v-else>Transfer</span>
                            <span class="smallText text-muted"> - {{row.item.statusPembayaran}}</span>
                        </div>
                    </div>
                </template>
                <template v-slot:cell(nominalPembayaran)="row">
                    <div class="text-right no-wrap" v-if="row.item.nominalPembayaran == null">{{$helper.addThousandSeparator(row.item.nominalPembayaran)}} </div>
                    <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.nominalPembayaran)}} </div>
                </template>
                <template v-slot:cell(angsuranPokok)="row">
                    <div class="text-right no-wrap" v-if="row.item.angsuranPokok == null">{{$helper.addThousandSeparator(row.item.angsuranPokok)}} </div>
                    <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.angsuranPokok)}} </div>
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge variant="dark" v-if="row.item.status == 'Baru'">BARU</b-badge>
                    <b-badge variant="success" v-else-if="row.item.status == 'Terbayar'">TERBAYAR</b-badge>
                    <b-badge variant="danger" v-else-if="row.item.status == 'Void'">VOID</b-badge>
                    <b-badge variant="warning" v-else-if="row.item.status == 'Request Void'">REQUEST VOID</b-badge>
                    <b-badge v-else>{{ row.item.status }}</b-badge>   
                </template>
                <template v-slot:head(status)>
                    Status 
                    <i class="fa fa-question tooltip-trigger-btn ml-1" @click="$bvModal.show('modal-info-status')"/>
                </template>
                <template v-slot:cell(action)="row">
                    <div class="no-wrap">
                        <b-button size="sm" class="table-button view" v-b-tooltip.hover title="Detail" name="historyBayarViewBtn" @click="viewHistoryBayar(row.item.id)">
                            <i class="fa fa-info"></i>
                        </b-button>
                    </div>
                </template>
            </b-table>
        </div>
        <div v-if="isShowListIdentitas">
            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title">IDENTITAS NASABAH</h6>
                <StateDetailHandler
                    :isLoading="stateListIdentitas.isLoading"
                    :isError="stateListIdentitas.isError"
                    :lines="5"
                    @retry="getListIdentitas"
                >
                    <ListIdentitas :dataIdentitas="stateListIdentitas.data" />
                </StateDetailHandler>
            </div>
        </div>
        <div v-if="!isApprovalPage">
            <FormMetodePencairan
                :userData="detailGadai.anggota"
                :dataGadai="detailGadai"
                @onFeeBank="onFeeBank"
                @onStatusDisbursed="onStatusDisbursed"
                @onSafeRetryReset="onSafeRetryReset"
                :hideListApprovalDisburse="hideListApprovalDisburse"
            />
        </div>
        <b-modal id="modal-detail-historyBayar" title="Detail History Pembayaran" no-close-on-backdrop>
            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title">DATA TRANSAKSI</h6>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label"><strong>No. Kwitansi</strong></b-col>
                    <b-col v-if="singleDetailPembayaran.noKwitansi != null"><strong>{{ singleDetailPembayaran.noKwitansi }}</strong></b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Cabang</b-col>
                    <b-col v-if="singleDetailPembayaran.cabangPembayaran != null">{{ singleDetailPembayaran.cabangPembayaran }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Status</b-col>
                    <b-col v-if="singleDetailPembayaran.status != null">{{ singleDetailPembayaran.status }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Status Pembayaran</b-col>
                    <b-col v-if="singleDetailPembayaran.statusPembayaran != null">{{ singleDetailPembayaran.statusPembayaran }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Jenis Pembayaran</b-col>
                    <b-col v-if="singleDetailPembayaran.jenisPembayaran != null">{{ singleDetailPembayaran.jenisPembayaran }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Metode Pembayaran</b-col>
                    <b-col v-if="singleDetailPembayaran.pembayaranTunai == true">Tunai</b-col>
                    <b-col v-else>Transfer</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Tanggal Pembayaran</b-col>
                    <b-col v-if="singleDetailPembayaran.tanggalPembayaran != null">{{$helper.changeDateFormat(singleDetailPembayaran.tanggalPembayaran)}}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
            </div>
            <div class="detail-data-wrapper mb-0">
                <h6 class="form-title">RINCIAN PEMBAYARAN</h6>
                <b-row class="mb-2" v-for="(item, idx) in dataDetailPembayaran.detail"  v-bind:key="idx">
                    <b-col cols="5" class="detail-data-label">{{item.name}}</b-col>
                    <b-col v-if="item.nominal == null">{{$helper.addThousandSeparator(item.nominal)}} </b-col>
                    <b-col v-else>Rp. {{$helper.addThousandSeparator(item.nominal)}} </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Angsuran Pokok</b-col>
                    <b-col v-if="dataDetailPembayaran.angsuranPokok == null">{{$helper.addThousandSeparator(dataDetailPembayaran.angsuranPokok)}} </b-col>
                    <b-col v-else>Rp. {{$helper.addThousandSeparator(dataDetailPembayaran.angsuranPokok)}} </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="5" class="detail-data-label">Total Pembayaran</b-col>
                    <b-col v-if="dataDetailPembayaran.nominalPembayaran == null">{{$helper.addThousandSeparator(dataDetailPembayaran.nominalPembayaran)}} </b-col>
                    <b-col v-else>Rp. {{$helper.addThousandSeparator(dataDetailPembayaran.nominalPembayaran)}} </b-col>
                </b-row>
            </div>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
                    Tutup
                </b-button>
            </template>
        </b-modal>
        <b-modal id="modal-info-status" title="Info Status" no-close-on-backdrop>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">BARU</h6>
                <p class="smallText mb-0">Transaksi gadai yang baru diinput dan belum ditransaksikan. Seluruh gadai BARU yang tidak dieksekusi, akan dihapus keesokan harinya.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">BERJALAN</h6>
                <p class="smallText mb-0">Transaksi gadai aktif yang sudah dieksekusi dan dicetak SBGnya.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">VOID</h6>
                <p class="smallText mb-0">Transaksi gadai sudah digugurkan (VOID).</p>
            </div>
            <div class="detail-data-wrapper mb-0">
                <h6 class="form-title mb-1">LUNAS</h6>
                <p class="smallText mb-0">Transaksi gadai sudah lunas.</p>
            </div>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
                    Tutup
                </b-button>
            </template>
        </b-modal>

        <b-modal id="modal-edit-imei" title="Edit No. IMEI / SN" no-close-on-backdrop>
            <div class="wrapper-edit-imei">
                <div class="wrapper-detail-edit-imei">
                    <p class="mb-0">No. IMEI / SN Lama</p>
                    <p class="mb-0 font-600">{{ detailGadai.barang.noImei }}</p>
                </div>
                <div>
                    <b-form-group label="No. IMEI / SN Baru">
                        <b-form-input v-model="formsImei.no" name="noImei"></b-form-input>
                    </b-form-group>
                </div>
            </div>
            <template v-slot:modal-footer="{ cancel, ok }">
                <b-button variant="secondary" :disabled="isLoadingSubmitImei" @click="cancel()">
                    Cancel
                </b-button>
                <b-button variant="primary" name="submitBtn" @click="onSubmitEditImei()" :disabled="isLoadingSubmitImei">
                    {{ isLoadingSubmitImei ? 'Mengirim...' : 'Submit' }}
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import FormMetodePencairan from '@/components/rekening/FormMetodePencairan'
import StateDetailHandler from '@/components/common/StateDetailHandler'
import ListIdentitas from '@/components/common/ListIdentitas'
import ModalFoto from '@/components/modals/ModalFoto'
import ImageCard from '@/components/common/ImageCard'

export default {
    name: 'detail-gadai',
    props: {
        detailGadai: { type: Object, required: true },
        detailMetodePencairan: { type: Object, default: () => null },
        isShowEditImei: { type: Boolean, default: false },
        isApprovalPage: { type: Boolean, default: false },
        isShowListIdentitas: { type: Boolean, default: false },
        isActiveFotoRight: { type: Boolean, default: false },
        isActiveFotoMobile: { type: Boolean, default: false },
        isFromCekGadai: { type: Boolean, default: false },
        isMobile: { type: Boolean, default: false },
        hideHistoryPembayaran: { type: Boolean, default: false },
        hideListApprovalDisburse: { type: Boolean, default: false },
    },
    components: {
        FormMetodePencairan,
        StateDetailHandler,
        ListIdentitas,
        ModalFoto,
        ImageCard,
    },
    data() {
        return {
            field: [
                { key: "noKwitansi", label: "No. Kwitansi", sortable: true },
                { key: "tanggalPembayaran", label: "Tanggal Pembayaran" },
                { key: "jenisPembayaran", label: "Jenis Pembayaran" },
                { key: "angsuranPokok", label: "Angsuran Pokok" },
                { key: "nominalPembayaran", label: "Total Pembayaran" },
                { key: "status", label: "Status" },
                { key: "action", label: "Aksi" },
            ],
            singleDetailPembayaran: {},
            dataDetailPembayaran: [],
            formsImei: {
                no: ''
            },
            isLoadingSubmitImei: false,
            feeBank: null,
            stateListIdentitas: {
                data: [],
                isLoading: false,
                isError: false,
            },
        }
    },
    methods: {
        init() {
            if (this.isShowListIdentitas) {
                this.getListIdentitas();
            }

            if (this.isApprovalPage) {
                this.feeBank = this.detailMetodePencairan.feeBank;
            }
        },
        viewHistoryBayar(id){
            this.$axios.get("gadai-pembayaran/"+id).then(response => {
                this.dataDetailPembayaran = response.data
                let idx = this.detailGadai.pembayaran.findIndex(item => item.id == id);
                this.singleDetailPembayaran = this.detailGadai.pembayaran[idx]

                this.$bvModal.show("modal-detail-historyBayar")
            })

            
        },
        onShowModalEditImei() {
            this.$bvModal.show("modal-edit-imei");
        },
        onSubmitEditImei() {
            this.isLoadingSubmitImei = true;
            const id = this.detailGadai.id;
            const imeiSn = this.formsImei.no;
            const isHandphone = this.detailGadai.barang.jenis.name === 'Handphone';

            if (!this.$helper.isValidImei(imeiSn) && isHandphone) {
                this.$helper.toastErr(this, "IMEI tidak valid, pastikan terdiri dari 15 karakter huruf atau angka.");
                this.isLoadingSubmitImei = false;
                return;
            }

            this.$axios.put(`gadai/update-imei?gadaiId=${id}&imeiSn=${imeiSn}`)
                .then((response) => {
                    this.$helper.toastSucc(this, 'No. IMEI / SN berhasil diperbarui.')
                    this.detailGadai.barang.noImei = imeiSn;
                    this.formsImei.no = '';
                    this.$bvModal.hide("modal-edit-imei");
                })
                .catch((error) => {
                    this.$helper.parseError(this, error)
                })
                .finally(() => {
                    this.isLoadingSubmitImei = false;
                })
        },
        getLabelAdaMerkPerusahaan(value) {
            if (value === true) return 'Ya'
            if (value === false) return 'Tidak'
            return '-'
        },
        onFeeBank(data) {
            this.feeBank = data;
        },
        onStatusDisbursed(data) {
            this.$emit('onStatusDisbursed', data)
        },
        onSafeRetryReset() {
            this.$emit('onSafeRetryReset')
        },
        getListIdentitas() {
            const params = {
                page: 0,
                size: 100,
                nasabahNo: this.detailGadai.anggota.noAnggota,
            }

            this.stateListIdentitas.isLoading = true;
            this.stateListIdentitas.isError = false;

            this.$axios.get('nasabah/get-nasabah-identitas', { params }).then(response => {
                this.stateListIdentitas.data = response.data.content[0].identitas;
            }).catch(error => {
                this.$helper.parseError(this, error);
                this.stateListIdentitas.isError = true;
            }).finally(() => {
                this.stateListIdentitas.isLoading = false;
            });
        },
        onActiveFoto() {
            if (this.isMobile) {
                this.$emit('onActiveFotoMobile')
            } else {
                this.$emit('onActiveFotoRight')
            }
        },

        openPreview(url) {
            window.open(url, '_blank')
        },
        formatCreatedBy(value) {
            const [name, username] = value.split(' - ')
            return `${name} (${username})`
        }
    },
    computed: {
        IS_HAVE_PERMISSION_EDIT_IMEI() {
            return this.$helper.hasPermissionMenuChildren('UGI');
        },
        IS_HAVE_PERMISSION_METODE_PENCAIRAN() {
            return this.$helper.hasPermissionMenuChildren('ABN');
        },
        showModalFoto() {
            return !this.isFromCekGadai
        },
        showFotoButton() {
            return this.isFromCekGadai
        },
        showHistoryPembayaran() {
            return !this.isApprovalPage && !this.hideHistoryPembayaran
        }
    },
    created() {
        this.init();
    },
}

</script>

<style scoped>
.gallery-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
}

.gallery-wrapper > span > a > img {
    border-radius: 4px;
}

.wrapper-edit-imei {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.wrapper-detail-edit-imei {
    display: flex;
    flex-direction: column;
    gap: 2px;
}
</style>
